module.exports = __webpack_public_path__ + "static/media/support.4ed329ea.svg";